import * as types from './types'
export const reload = ({ commit },data ) => {
  commit(types.RELOAD, data); // 发送指令，存储数据
}

export const loadPre = ({commit},data)=>{
  commit(types.PRE_LOAD, data);
}

export const loadPost = ({commit},data)=>{
  commit(types.POST_LOAD, data);
}
